<template>
  <div>
    <div v-if="isExternalLink">
      <a :href="url" :class="classList">
        <i :class="icon"></i> {{name}}
        <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      </a>
    </div>
    <div v-else>
      <router-link :to="url" :class="classList">
        <i :class="icon"></i> <a v-on:click="getOrderNewCnt()">{{name}}</a>
        <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
        <span
          v-if="name == '고객문의' && qnaCnt > 0"
          class="badge badge-danger"
          style="font-size: 12px; vertical-align: middle; margin-bottom:-4px;" >
          {{qnaCnt}}
        </span>
        <span
          v-if="name == '보고서상품 주문' && rpCnt > 0"
          class="badge badge-danger"
          style="font-size: 12px; vertical-align: middle; margin-bottom:-4px;" >
          {{rpCnt}}
        </span>
        <span
          v-if="name == '구독회원 주문' && apCnt > 0"
          class="badge badge-danger"
          style="font-size: 12px; vertical-align: middle; margin-bottom:-4px;" >
          {{apCnt}}
        </span>
      </router-link>
    </div>

  </div>
</template>

<script>
import {EventBus} from "../../views/event-bus";

export default {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      qnaCnt: 0,
      rpCnt: 0,
      apCnt: 0,
    }
  },
  mounted: function() {
    this.getOrderNewCnt();
  },
  // qna 문의 넘버링 노출용 이벤트 버스
  created() {
    EventBus.$on('changeQnaCnt', (qnaCnt) => {
      this.qnaCnt = qnaCnt;
    });
    EventBus.$on('changeRpCnt', (rpCnt) => {
      this.rpCnt = rpCnt;
    });
    EventBus.$on('changeApCnt', (apCnt) => {
      this.apCnt = apCnt;
    });
  },
  computed: {
    classList () {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    linkVariant () {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses () {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink () {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    getOrderNewCnt() {
      this.$session.remove('search_user_id');
      // this.$store.dispatch('ORDERTOTALCNT', this);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavLink.vue